angular.module('cvsApp').service('generateReportService',['networkService', 'xdrService', 'configManager', 'generateReportModel', function (NS, XS, CM, GRM) {

	function generateReportService (){
		this.generateReport = function(requestData, callBackSuccess){
			//get url
			var url = CM.getApiUrl('GET_REPORT', cvsUtility.queryMap.tokenId, 'Login');
			if(url === "URL_ERROR"){

			}else{
				if (cvsUtility.getIEVersion() <= 9) {
					XS.makeRequest(url, getRequestBody(requestData), xdrSuccess);

					function xdrSuccess (data) {
						callBackSuccess(data);
					}
				}
				else {
					var request = {url:url,
							header:{
								"Content-Type":"application/xml"
							},
							data:getRequestBody(requestData),
							onSuccess:callBackSuccess
						}
					var promise = NS.post(request);
					promise.then(function(data, c, d){
						//console.log(data)
						callBackSuccess(data.data);

						//send message to parent
						//cvsUtility.sendPostMessage("SESSION-ALIVE","generateReportService");

					}, function(reason){
						callBackSuccess(NS.httpError(reason));
					});					
				}
			}

		}

		var getRequestBody = function(requestData){
				var date = new Date();
				//var currentYear = date.getFullYear();
				//var currentMonth =convertToTwoDigit(date.getMonth() + 1);
				//var currentDay = convertToTwoDigit(date.getDate());
				var currentYear = requestData.endDate.getFullYear();
				var currentMonth =convertToTwoDigit(requestData.endDate.getMonth()+1);
				var currentDay = convertToTwoDigit(requestData.endDate.getDate());

				var startYear = requestData.startDate.getFullYear();
				var startMonth = convertToTwoDigit(requestData.startDate.getMonth()+1);
				var startDay = convertToTwoDigit(requestData.startDate.getDate());
				var paymentHistoryHeader = requestData.paymentHistoryHeader;
				var customerName = paymentHistoryHeader.customerName.firstName + ' ' +
					(paymentHistoryHeader.customerName.middleName || '') + ' '+ paymentHistoryHeader.customerName.lastName;

				var hour = convertToTwoDigit(date.getHours());
				var minute = convertToTwoDigit(date.getMinutes());
				var second = convertToTwoDigit(date.getSeconds());

				var timeStamp = currentYear + '-' + currentMonth + '-' + currentDay + 'T' + hour
					+ ':' + minute + ':' + second;

				var transaction = [];
				var grp = 0;

				for(grp in requestData.groups) {
					var obj = {};
					obj.sequenceNumber = parseInt(grp, 10) + 1;
					obj.transactionHeader = {
						site: requestData.groups[grp][0].site,
						pharmacyLocation: requestData.groups[grp][0].pharmacyLocation,
						taxId: requestData.groups[grp][0].taxId
					}

					for (var i=0 in requestData.groups[grp]) {
						requestData.groups[grp][i] = _.omit(requestData.groups[grp][i], ['site', 'pharmacyLocation', 'taxId', '$$hashKey']);
						requestData.groups[grp][i].itemName = (requestData.isHideMedication === 1) ? 'PRIVATE' : requestData.groups[grp][i].itemName;
					}

					obj.transactionDetails = {
						transactionDetail: requestData.groups[grp]
					};
					transaction.push(obj)
				}
				var requestJson = {request:{
								tokenID:cvsUtility.queryMap.tokenId,
								tokenType:"Login",
								apiKey:cvsUtility.queryMap.apikey,
								timestamp:timeStamp,
								reportType: requestData.type,
								reportHeader: {
									fileName: requestData.fileName + '.' + requestData.type,
									headerText: 'VIEW PAYMENT HISTORY',
									// logoUrl: '',
									startDate: startMonth + '/' + startDay + '/' + startYear,
									endDate:  currentMonth + '/' + currentDay + '/' + currentYear
								},
								reportFooter: {
									footerNote: 'Proprietary & Confidential'
								},
								paymentHistoryHeader: {
									customerName: customerName,
									billingAddress: {
										line1: paymentHistoryHeader.billingAddress.addressLine1,
										line2: paymentHistoryHeader.billingAddress.addressLine2,
										city: paymentHistoryHeader.billingAddress.city,
										state: paymentHistoryHeader.billingAddress.state,
										zipCode: paymentHistoryHeader.billingAddress.zipCode,
										zipCodeExt: paymentHistoryHeader.billingAddress.zipCodeExt
									}
								},
								paymentHistoryFooter: {
									insuranceTotalByCharges: paymentHistoryHeader.insuranceTotalByCharges,
									insuranceTotalByPayments: paymentHistoryHeader.insuranceTotalByPayments,
									insuranceTotalByAdjustments: paymentHistoryHeader.insuranceTotalByAdjustments,
									insuranceTotalByBalance: paymentHistoryHeader.insuranceTotalByBalance,
									patientTotalByCharges: paymentHistoryHeader.patientTotalByCharges,
									patientTotalByPayments: paymentHistoryHeader.patientTotalByPayments,
									patientTotalByAdjustments: paymentHistoryHeader.patientTotalByAdjustments,
									patientTotalByBalance: paymentHistoryHeader.patientTotalByBalance,
									reportTotalByCharges: paymentHistoryHeader.reportTotalByCharges,
									reportTotalByPayments: paymentHistoryHeader.reportTotalByPayments,
									reportTotalByAdjustments: paymentHistoryHeader.reportTotalByAdjustments,
									reportTotalByBalance: paymentHistoryHeader.reportTotalByBalance
								},
								transactions: {
									transaction: transaction
								}
								}}
				return cvsUtility.JSONToXml(requestJson);

				function convertToTwoDigit (number) {
					return (number < 10) ? '0' + number : number;
				}
			}
	}

	return new generateReportService();
}]);
